module.exports = __webpack_public_path__ + "img/shanhu1.d1b4dfb2.png";